var exports = {
  "az": "Box__voquiz",
  "wy": "Box_1__ry5Ku9",
  "ws": "Box_5__zhQdng",
  "D6": "Box_6__FhdYBd",
  "KI": "Box_7__neulzb",
  "EY": "Text__lcFYq9",
  "Qg": "ToastAction___UkeQM",
  "EO": "Blankslate__88jGu5",
  "m4": "Octicon__nODpig",
  "UE": "Text_1__Qh4AD4",
  "Tu": "IconContainer__PkyRuz",
};

module.exports = exports;
